import React from "react";
import { Box, Card, Typography } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./socDashboard.module.scss";

const data = [
  { hour: 0, critical: 2, high: 10, medium: 20 },
  { hour: 1, critical: 1, high: 8, medium: 18 },
  { hour: 2, critical: 1, high: 6, medium: 19 },
  { hour: 3, critical: 2, high: 9, medium: 16 },
  { hour: 4, critical: 1, high: 5, medium: 16 },
  { hour: 5, critical: 0, high: 3, medium: 19 },
  { hour: 6, critical: 0, high: 8, medium: 24 },
  { hour: 7, critical: 3, high: 11, medium: 26 },
  { hour: 8, critical: 1, high: 6, medium: 32 },
  { hour: 9, critical: 4, high: 14, medium: 30 },
  { hour: 10, critical: 1, high: 5, medium: 10 },
  { hour: 11, critical: 0, high: 6, medium: 22 },
  { hour: 12, critical: 1, high: 9, medium: 18 },
  { hour: 13, critical: 0, high: 7, medium: 14 },
  { hour: 14, critical: 0, high: 2, medium: 15 },
  { hour: 15, critical: 1, high: 3, medium: 16 },
  { hour: 16, critical: 2, high: 7, medium: 20 },
  { hour: 17, critical: 1, high: 11, medium: 26 },
  { hour: 18, critical: 0, high: 6, medium: 22 },
  { hour: 19, critical: 1, high: 10, medium: 20 },
  { hour: 20, critical: 2, high: 12, medium: 15 },
  { hour: 21, critical: 1, high: 9, medium: 12 },
  { hour: 22, critical: 0, high: 5, medium: 14 },
  { hour: 23, critical: 2, high: 8, medium: 18 },
];

export const SocAlertTimeline = () => {
  return (
    <Card className={`${styles.card} ${styles.timelineCard}`}>
      <Typography className={styles.timelineTitle}>Alert Timeline - Last 24 Hours</Typography>
      <Box height={320}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorCritical" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#f87171" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#f87171" stopOpacity={0.05} />
              </linearGradient>
              <linearGradient id="colorHigh" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#fbbf24" stopOpacity={0.35} />
                <stop offset="95%" stopColor="#fbbf24" stopOpacity={0.05} />
              </linearGradient>
              <linearGradient id="colorMedium" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#60a5fa" stopOpacity={0.35} />
                <stop offset="95%" stopColor="#60a5fa" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="hour" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Area type="monotone" dataKey="medium" stroke="#60a5fa" fill="url(#colorMedium)" stackId="1" />
            <Area type="monotone" dataKey="high" stroke="#fbbf24" fill="url(#colorHigh)" stackId="1" />
            <Area type="monotone" dataKey="critical" stroke="#f87171" fill="url(#colorCritical)" stackId="1" />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default SocAlertTimeline;
